import React, { useEffect } from "react";
import { useVeltClient } from "../context";
export function useViewsUtils() {
    var _a = React.useState(), viewsElement = _a[0], setViewsElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || viewsElement)
            return;
        var loadedViewsElement = client.getViewsElement();
        setViewsElement(loadedViewsElement);
    }, [client, setViewsElement, viewsElement]);
    return viewsElement;
}
export function useUniqueViewsByUser(clientLocationId) {
    var viewsElement = useViewsUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the input
    var memoizedClientLocationId = React.useMemo(function () { return clientLocationId; }, [clientLocationId]);
    useEffect(function () {
        if (!(viewsElement === null || viewsElement === void 0 ? void 0 : viewsElement.getUniqueViewsByUser))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = viewsElement.getUniqueViewsByUser(memoizedClientLocationId).subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [viewsElement === null || viewsElement === void 0 ? void 0 : viewsElement.getUniqueViewsByUser, memoizedClientLocationId]);
    return data;
}
export function useUniqueViewsByDate(clientLocationId) {
    var viewsElement = useViewsUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the input
    var memoizedClientLocationId = React.useMemo(function () { return clientLocationId; }, [clientLocationId]);
    useEffect(function () {
        if (!(viewsElement === null || viewsElement === void 0 ? void 0 : viewsElement.getUniqueViewsByDate))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = viewsElement.getUniqueViewsByDate(memoizedClientLocationId).subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [viewsElement === null || viewsElement === void 0 ? void 0 : viewsElement.getUniqueViewsByDate, memoizedClientLocationId]);
    return data;
}
